import React from "react";
import "./customer-list.css";
import CustomerItem from "./customer-item/CustomerItem";
import { Skeleton } from "components/skeleton";

export interface Customer {
  rank: number;
  id: string;
  orders: number;
  lastVisit: string;
  total: string;
  vip: string;
}

export type RankVariant = "gold" | "silver" | "bronze" | "default";

function getRankVariant(rank: number): RankVariant {
  if (rank === 1) return "gold";
  if (rank === 2) return "silver";
  if (rank === 3) return "bronze";
  return "default";
}

interface Props {
  customers: Customer[];
  title?: string;
  meta?: string;
  /** Unit for each row total. */
  unit?: string;
  /** Show shimmer rows instead of data while payments load. */
  loading?: boolean;
}

function CustomerList({
  customers,
  title = "Top customers",
  meta,
  unit = "",
  loading = false,
}: Props) {
  return (
    <section className="customer-list">
      <div className="customer-list__header">
        <h3 className="customer-list__title">{title}</h3>
        {meta && <span className="customer-list__meta">{meta}</span>}
      </div>

      {loading ? (
        <div className="customer-list__items">
          {Array.from({ length: 5 }, (_, i) => (
            <div className="customer-list__item" key={i}>
              <Skeleton width={28} height={28} borderRadius="8px" />
              <div className="customer-list__info">
                <Skeleton width={120} height={12} />
                <Skeleton
                  width={90}
                  height={11}
                  className="customer-list__sk-sub"
                />
              </div>
              <Skeleton width={64} height={14} />
            </div>
          ))}
        </div>
      ) : customers.length === 0 ? (
        <div className="customer-list__empty">No top customers.</div>
      ) : (
        <div className="customer-list__items">
          {customers.map((c) => {
            const variant = getRankVariant(c.rank);
            return (
              <CustomerItem
                customer={c}
                variant={variant}
                unit={unit}
                key={c.id}
              />
            );
          })}
        </div>
      )}
    </section>
  );
}

export default CustomerList;
